import React from 'react';
import { withTheme } from 'styled-components';

const CleanArrowPrevious = ({ theme, color = theme.colors.Foreground, className }) => (
    <svg
        className={className}
        width="10px"
        height="18px"
        viewBox="0 0 10 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Final-"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g
                id="Halo-Desktop"
                transform="translate(-89.000000, -7348.000000)"
                stroke={color}
                strokeWidth="2"
            >
                <g id="Reco" transform="translate(72.000000, 7103.000000)">
                    <g id="Prev" transform="translate(0.000000, 230.000000)">
                        <g
                            id="ic_forward"
                            transform="translate(22.000000, 24.000000) scale(-1, 1) translate(-22.000000, -24.000000) translate(10.000000, 12.000000)"
                        >
                            <g
                                transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
                                id="ic_back"
                            >
                                <g>
                                    <g id="back" transform="translate(8.000000, 4.000000)">
                                        <path d="M8,0 L0,8" id="Line" />
                                        <path d="M0,8 L8,16" id="Line" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default withTheme(CleanArrowPrevious);
